export default __webpack_public_path__ + "static/media/hero-lp.f52d4d82.png";